import type { IndustryPartnerDirectory } from '@conference/shared';
import PartnerCard from './PartnerCard';

export default function IndustryPartnerDirectoryPanel({ directory, onOpen }: {
  directory: IndustryPartnerDirectory;
  onOpen: (id: string) => void;
}) {
  return <section>
    <div className="space-y-2">{directory.partners.map((partner) => (
      <PartnerCard key={partner.id} partner={partner} onOpen={onOpen} />
    ))}</div>
  </section>;
}
